import { JSX } from 'react';
import customIcons from '../../utils/icons';

export default function ResourceCard({
  resourceType, resource, icon, redirectUrl,
}: { resourceType?: string; resource?: string; icon?: JSX.Element; redirectUrl: string }) {
  return (
    <div id="resrouce-card-container" className="card flex flex-row grow items-center flex-1 gap-4 in-w-[150px] font-normal w-full">
      <div id="resource-card-icon-container" className="base-container"><span id="resource-icon-icon">{icon}</span></div>
      <div className="flex flex-col">
        <span className="text-xs text-secondary text-wrap">{resourceType}</span>
        <p className="text-sm font-medium text-primary">{resource}</p>
      </div>
      <div
        id="resource-card-redirect-container"
        className="base-container ml-auto"
      >
        <a
          className="text-primary hover:text-primary-dark"
          id="chevron-right-navigate"
          target="_blank"
          rel="noopener noreferrer"
          href={redirectUrl}
        >
          {customIcons.chevronRight}
        </a>
      </div>
    </div>
  );
}
